// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"c1456ab7","453":"a91d2c69","490":"622c8e00"}[chunkId] + ".chunk.js";
};